export class LocalCompany {
    idCompany = 0;
    idLocal = 0; 
    name = '';
    address = '';
    phone = '';
    normalizedPhone = '';
    countryId: string;
    locationId: number;
    locationHierarchy = [];
    district_id = 0;
    department_id = '';
    province_id = 0;
    stateLocal = true;

    // constructor(idCompany:number, idLocal:number, name:string,
    //     address:string, phone:string, department_id:string, 
    //     province_id:number, district_id:number) {
        
    //     this.idCompany = idCompany;
    //     this.idLocal = idLocal;
    //     this.name = name;
    //     this.address = address;
    //     this.phone = phone;
    //     this.department_id = department_id;
    //     this.province_id = province_id;
    //     this.district_id = district_id;

    // }
  }
  